"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPRESS_LOCAL_TESTING_PORT = exports.CUSTOM_CLAIMS_CHAR_LIMIT = void 0;
exports.CUSTOM_CLAIMS_CHAR_LIMIT = 990;
exports.EXPRESS_LOCAL_TESTING_PORT = 3010;
//# sourceMappingURL=constants.js.map